<template>
      <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 md6>
        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/bWeW1JiL640" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </v-flex>
      <v-flex xs12 sm6 md6>
        <iframe width="100%" height="315" src="https://www.youtube.com/embed/VLKuHuqKhuA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </v-flex>
    </v-layout>
      </v-container>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>